import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Quote } from "lucide-react";
import { TESTIMONIALS } from "../lib/data";

export default function Testimonials() {
  const [i, setI] = useState(0);
  const t = TESTIMONIALS[i];

  return (
    <section
      id="testimonials"
      className="relative py-24 md:py-32 border-t border-white/10 overflow-hidden"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <div className="grid grid-cols-12 gap-8 md:gap-12 items-center">
          <div className="col-span-12 md:col-span-5">
            <span className="em-tag">05 — In their words</span>
            <h2
              className="mt-6 font-display font-extrabold tracking-tighter leading-[0.98]"
              style={{ fontSize: "clamp(1.8rem, 3.6vw, 3.4rem)" }}
            >
              What our partners say.
            </h2>

            <div className="mt-10 flex gap-2">
              {TESTIMONIALS.map((_, idx) => (
                <button
                  key={idx}
                  onClick={() => setI(idx)}
                  data-testid={`testimonial-dot-${idx}`}
                  aria-label={`Testimonial ${idx + 1}`}
                  className={`h-1.5 w-10 transition-[background-color,transform] duration-500 rounded-full ${
                    i === idx ? "bg-white" : "bg-white/20 hover:bg-white/40"
                  }`}
                />
              ))}
            </div>
          </div>

          <div className="col-span-12 md:col-span-7">
            <AnimatePresence mode="wait">
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -20 }}
                transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
                className="em-card p-8 md:p-10"
              >
                <Quote
                  size={32}
                  className="text-white/25"
                  strokeWidth={1.4}
                />
                <p
                  className="mt-5 font-display font-medium tracking-tight leading-[1.2]"
                  style={{ fontSize: "clamp(1.2rem, 1.8vw, 1.7rem)" }}
                >
                  “{t.quote}”
                </p>

                <div className="mt-8 flex items-center gap-4 border-t border-white/10 pt-5">
                  <div className="h-12 w-12 overflow-hidden border border-white/10 grayscale">
                    <img
                      src={t.img}
                      alt={t.name}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div>
                    <div className="font-mono-em text-[0.65rem] tracking-[0.24em] uppercase text-white/50">
                      Client
                    </div>
                    <div className="font-display font-bold text-base leading-tight mt-1">
                      {t.name}
                    </div>
                    <div className="text-white/55 text-xs">{t.role}</div>
                  </div>
                </div>
              </motion.div>
            </AnimatePresence>
          </div>
        </div>
      </div>
    </section>
  );
}
